import { useSoftwareEscrow } from 'src/context/software-escrow';
import { OrganizationCard, EscrowInvitationCard, useParty } from 'src/containers/Escrow/Summary';

const PartyCard = () => {
  const { type, party } = useParty();
  const {
    softwareEscrow: { escrowInvitation, currentCompanyRole, startedBy },
  } = useSoftwareEscrow();

  const isCreator = currentCompanyRole === startedBy;

  if (!(currentCompanyRole === type || isCreator)) return null;

  return party ? <OrganizationCard /> : <EscrowInvitationCard escrowInvitation={escrowInvitation!} />;
};

export default PartyCard;
